import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

// Import GIFs
import gif1 from '../media/cpl1.gif';
import gif2 from '../media/cpl2.gif';
import gif3 from '../media/cpl3.gif';
import gif4 from '../media/cpl4.gif';
import gif5 from '../media/cpl5.gif';
import gif6 from '../media/cpl6.gif';

// Phrases for loading text
const phrases = [
  "Initializing quantum analysis of competitor strategies...",
  "Generating neural networks to decode competitor patterns...",
  "Engaging the algorithmic engines to extract competitive insights...",
  "Conducting Bayesian inference on competitor data streams...",
  "Applying chaos theory to uncover hidden competitive dynamics...",
  "Harnessing the power of statistical mechanics to reveal competitor behavior...",
  "Utilizing fractal analysis to explore the complexity of competitive landscapes...",
  "Initiating genetic algorithms to optimize competitive strategy discovery...",
  "Employing machine learning algorithms to predict competitor moves...",
  "Deploying computational models to simulate competitive scenarios...",
  "Uncovering the competitor's digital footprint...",
];

const GIF_COUNT = 6;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const GIFImage = styled.img`
  max-width: 300px;
  height: auto;
  transition: opacity 0.5s ease-in-out;
  opacity: ${({ visible }) => visible ? 1 : 0};
`;

const LoadingText = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #8884d8;
`;

const CPLoading = () => {
  const [currentGIF, setCurrentGIF] = useState(1);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentGIF(prevGIF => (prevGIF % GIF_COUNT) + 1);
      }, 600);
      setVisible(true);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  // Select the current GIF based on the index
  const gif = (() => {
    switch (currentGIF) {
      case 1:
        return gif1;
      case 2:
        return gif2;
      case 3:
        return gif3;
      case 4:
        return gif4;
      case 5:
        return gif5;
      case 6:
        return gif6;
      default:
        return null;
    }
  })();



  const [time, setTime] = useState((3 * 60) + 30);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(intervalId);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  return (
    <LoadingContainer>
      <GIFImage
        src={gif}
        alt={`Loading ${currentGIF}`}
        visible={visible}
      />
      <LoadingText>{phrases[currentGIF - 1]}</LoadingText>
      <p style={{color: '#8884d8', marginBlock: '20px'}}>It will take approximately <strong>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</strong> to retrieve the data as we ensure it is the most current and up-to-date information available</p>
    
      <NOTE><ReportProblemIcon /> <p>Our Competition Project is in Beta Mode—new insights and optimizations
       are on the way, but it may not work perfectly yet!</p></NOTE>
    </LoadingContainer>
  );
};

export default CPLoading;


const ColorEffect = keyframes`
  0%{
    color: #8884d8;
    filter: brightness(100%);
  }

  50% {
    color: #8884d8;
    filter: brightness(150%);
  }

  100% {
    color: #8884d8;
    filter: brightness(100%);
  }
`

const NOTE = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 30px;

  > .MuiSvgIcon-root {
    animation: ${ColorEffect} 3s ease-in-out infinite;
  }

  > p {
    animation: ${ColorEffect} 3s ease-in-out infinite;
  }
`